import { render, staticRenderFns } from "./Bestellungen.vue?vue&type=template&id=c05a5b3e&scoped=true&"
import script from "./Bestellungen.vue?vue&type=script&lang=ts&"
export * from "./Bestellungen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05a5b3e",
  null
  
)

export default component.exports